import React, {useState, useContext} from 'react';
import { Dimensions, View } from 'react-native';
import {
  ChatModal,
  ModalContainer,
  ModalContent,
} from './elements';
import ChatHeader from './ChatHeader';
import MessageInputContext from '../../contexts/MessageInputContext';

const Modal = props => {
  const { setCurrentConversationId } = useContext(MessageInputContext);
  const {
    showModal,
    setShowModal,
    modalType,
    children,
    objectName,
    pendingResponse
  } = props;
  const screenHeight = Dimensions.get('window').height - 100
  return (
    <ModalContainer
      // onPress={() => setShowModal(false)}
    >
      {/* <DefaultModal
        visible={showModal}
        transparent={true}
      > */}
        <ChatModal
          onClick={() => false}
          conversationsIndex={true}
        >
          <ChatHeader
            title={`${modalType}${objectName ? ' - ' + objectName : ''}`}
            pendingResponse={pendingResponse}
            onMinimize={() => setShowModal(false)}
          />
          <ModalContent>
            <View style={{ height: "auto", maxHeight: screenHeight, flex: 1 }}>
              { children }
            </View>
          </ModalContent>
        </ChatModal>
      {/* </DefaultModal> */}
    </ModalContainer>
  )
}

export default Modal;